export const RESET_APP = "RESET_APP";